// Actions
import ErrorActions from 'app/shared/flux/actions/ErrorActions';
import ListingEngineActions from 'app/shared/flux/actions/ListingEngineActions';

// Types
import type { ThunkDispatch } from 'redux-thunk';
import type { AnyAction } from 'redux';
import type { RootReduxState } from 'app/shared/flux/reducers/index';

// Define interfaces for better type safety
interface Trace {
  finishAsyncSpan: (params: { marker: string }) => void;
}

interface ReduxStore {
  getState: () => RootReduxState;
  dispatch: ThunkDispatch<RootReduxState, undefined, AnyAction>;
}

interface ReactContext {
  store: ReduxStore;
  trace: Trace;
}

const fetchNearbyAreasListings = (
  reactContext: ReactContext,
  { areaResourceId }: { areaResourceId: string },
): Promise<unknown> => {
  const { store, trace } = reactContext;

  return store
    .dispatch(ListingEngineActions.fetchNearbyAreasListings(areaResourceId))
    .then((response: unknown) => {
      trace.finishAsyncSpan({
        marker: 'FetchAreaWrapper#fetchNearbyAreasListings',
      });

      return response;
    })
    .catch((error: Error) => {
      store.dispatch(
        ErrorActions.errorHandler({
          error,
          errorLocation: 'component.areaPage.serverRouteWillMount#fetchNearbyAreasListings',
          errorClass: 'listingEngineActions',
        }),
      );
    });
};

export default fetchNearbyAreasListings;
